import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

/** Template-management library (epic #167). All endpoints are feature-flag gated server-side. */
@Injectable({
  providedIn: 'root',
})
export class TemplateManagementService {
  constructor(private apiService: ApiBaseService) {}

  async getTemplateTree(payload: any = {}): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/GetTemplateTree', payload, true, true);
  }

  async writeTemplateFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/WriteTemplateFolder', payload, true, true);
  }

  async moveTemplateFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/MoveTemplateFolder', payload, true, true);
  }

  async getTemplateFolderDeleteInfo(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/GetTemplateFolderDeleteInfo', payload, true, true);
  }

  async deleteTemplateFolder(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/DeleteTemplateFolder', payload, true, true);
  }

  async uploadTemplateDocument(formData: FormData): Promise<any> {
    return this.apiService.httpRequestForm('TemplateManagementService/UploadTemplateDocument', formData, true, true);
  }

  async renameTemplateDocument(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/RenameTemplateDocument', payload, true, true);
  }

  async moveTemplateDocument(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/MoveTemplateDocument', payload, true, true);
  }

  async deleteTemplateDocument(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/DeleteTemplateDocument', payload, true, true);
  }

  async getTemplateDocumentFile(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/GetTemplateDocumentFile', payload, true, true);
  }

  /** Template tree scoped to the folder linked in contract management (#690); full tree while unlinked. */
  async getContractTemplateTree(payload: any = {}): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/GetContractTemplateTree', payload, true, true);
  }

  async getContractTemplateSettings(payload: any = {}): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/GetContractTemplateSettings', payload, true, true);
  }

  async saveContractTemplateSettings(payload: any): Promise<any> {
    return this.apiService.httpRequest('TemplateManagementService/SaveContractTemplateSettings', payload, true, true);
  }
}
